package com.eladfinish.bible.contest.analytics.providers

import com.eladfinish.bible.contest.analytics.ads.AdContext
import com.eladfinish.bible.contest.analytics.ads.AdRevenueValue
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.analytics.analytics
import io.github.aakira.napier.Napier

interface AnalyticsProvider {
    // iOS currently has no AppMetrica SDK. Platform providers opt into native revenue reporting.
    fun reportAdRevenue(context: AdContext, value: AdRevenueValue) = Unit

    fun logEvent(event: String, params: Map<String, Any>?) {
        Napier.d("AnalyticsProvider_logEvent $event $params")
        val firebaseEvent = FirebaseEvent.from(event, params)
        Firebase.analytics.logEvent(name = firebaseEvent.name, parameters = firebaseEvent.params)
    }

    fun logEvent(event: String) {
        logEvent(event = event, params = null)
    }
}
